/*! Version: b91cd8f9 */
webpackJsonp([4],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(108);

__webpack_require__(115);

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = __webpack_require__(109);

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _locale = __webpack_require__(8);

var _locale2 = _interopRequireDefault(_locale);

var _newsItems = __webpack_require__(112);

var _newsItems2 = _interopRequireDefault(_newsItems);

var _calendarFormats = __webpack_require__(113);

var _calendarFormats2 = _interopRequireDefault(_calendarFormats);

var _carouselImageLabels = __webpack_require__(114);

var _carouselImageLabels2 = _interopRequireDefault(_carouselImageLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Date formatting settings for moment.js
/* globals window document */
// Home-specific js

var apiURL = "/api/fb_feed";

//onload

//Labels for the carousel images
(0, _jquery2.default)(function () {
  setupCarousel();
  setupNews();
});

function setupCarousel() {
  initializeSlick();
  setupCarouselIndicators();
  setupPlayPauseButton();
  setupImageLabels();
}

function initializeSlick() {
  //if site is in rtl mode
  if ((0, _jquery2.default)("html").attr("dir") == "rtl") {
    setupSlickObject();

    (0, _jquery2.default)(".c-carousel__images").slick("slickSetOption", "rtl", true, true);

    //add the rtl images
    var i;
    for (i = 1; i < 6; i++) {
      (0, _jquery2.default)(".c-carousel__images").slick("slickAdd", '<div class="c-carousel__image c-carousel__image--image' + i + '-rtl"></div>');
    }
  }

  //if site is in ltr mode
  else {
      setupSlickObject();

      //add the ltr images
      var j;
      for (j = 1; j < 6; j++) {
        (0, _jquery2.default)(".c-carousel__images").slick("slickAdd", '<div class="c-carousel__image c-carousel__image--image' + j + '"></div>');
      }
    }
}

function setupSlickObject() {
  (0, _jquery2.default)(".c-carousel__images").slick({
    accessibility: true,
    dots: true,
    appendDots: (0, _jquery2.default)(".c-carousel__indicators-container"),
    dotsClass: "u-custom-slick-dots",
    arrows: false,
    autoplay: true,
    autoplaySpeed: 7000,
    fade: true,
    cssEase: "ease-in-out",
    speed: 1000,
    swipe: true
  });

  //remove previous images
  (0, _jquery2.default)(".c-carousel__images").slick("removeSlide", null, null, true);
}

function setupCarouselIndicators() {
  (0, _jquery2.default)(".u-custom-slick-dots").find("li").addClass("i-carousel-indicator"); //add the indicator icons
  (0, _jquery2.default)(".u-custom-slick-dots").find("li").addClass("c-carousel__indicator"); //add the indicator class

  (0, _jquery2.default)(".c-carousel__indicator").find("button").addClass("c-carousel__indicator-button");
  (0, _jquery2.default)(".c-carousel__indicator").find("button").addClass("u-focus-white-outline");

  (0, _jquery2.default)(".u-custom-slick-dots").children().eq(0).removeClass("i-carousel-indicator");
  (0, _jquery2.default)(".u-custom-slick-dots").children().eq(0).addClass("i-carousel-indicator-selected");

  //set up the selected indicator
  (0, _jquery2.default)(".c-carousel__images").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var currentSlideObj = (0, _jquery2.default)(".u-custom-slick-dots").children().eq(currentSlide);
    var nextSlideObj = (0, _jquery2.default)(".u-custom-slick-dots").children().eq(nextSlide);

    currentSlideObj.removeClass("i-carousel-indicator-selected");
    currentSlideObj.addClass("i-carousel-indicator");

    nextSlideObj.removeClass("i-carousel-indicator");
    nextSlideObj.addClass("i-carousel-indicator-selected");
  });
}

function setupPlayPauseButton() {
  (0, _jquery2.default)(".c-carousel__play-pause-button").click(function () {
    if ((0, _jquery2.default)(".c-carousel__play-pause-button").hasClass("i-pause")) {
      (0, _jquery2.default)(".c-carousel__images").slick("slickPause");
      (0, _jquery2.default)(".c-carousel__play-pause-button").removeClass("i-pause");
      (0, _jquery2.default)(".c-carousel__play-pause-button").addClass("i-play");
    } else {
      (0, _jquery2.default)(".c-carousel__images").slick("slickPlay");
      (0, _jquery2.default)(".c-carousel__play-pause-button").removeClass("i-play");
      (0, _jquery2.default)(".c-carousel__play-pause-button").addClass("i-pause");
    }
  });
}

function setupImageLabels() {
  var labels = [];

  switch (_locale2.default) {
    case "en_US":
      labels = _carouselImageLabels2.default.english;
      break;
    case "he_IL":
      labels = _carouselImageLabels2.default.hebrew;
      break;
    case "de_DE":
      labels = _carouselImageLabels2.default.german;
      break;
    case "ru_RU":
      labels = _carouselImageLabels2.default.russian;
      break;
    case "ar_EG":
      labels = _carouselImageLabels2.default.arabic;
      break;
  }

  var carouselImages = (0, _jquery2.default)(".c-carousel__image");

  for (var i = 0; i < carouselImages.length; i++) {
    (0, _jquery2.default)(carouselImages[i]).attr("aria-label", labels[i]);
    (0, _jquery2.default)(carouselImages[i]).attr("aria-label", labels[i]);
  }
}

function setupNews() {
  new _vue2.default({
    el: "#news-items",

    data: {
      items: []
    },

    template: _newsItems2.default,

    created: function created() {
      this.fetchNewsData();
    },

    updated: function updated() {
      truncateNews();
    },

    methods: {
      fetchNewsData: function fetchNewsData() {
        var dateRaw;
        var self = this;

        _jquery2.default.get(apiURL, function (data) {
          self.items = data;
          var arrayLength = self.items.length;

          for (var i = 0; i < arrayLength; i++) {
            dateRaw = self.items[i].date;
            self.items[i].date = localizeDate(dateRaw);
          }
        });
      }
    }
  });
}

function localizeDate(dateRaw) {
  var myMoment = (0, _moment2.default)(dateRaw);
  myMoment.locale(_locale2.default);

  switch (_locale2.default) {
    case "en_US":
      return myMoment.calendar(null, _calendarFormats2.default.english);
    case "he_IL":
      return myMoment.calendar(null, _calendarFormats2.default.hebrew);
    case "de_DE":
      return myMoment.calendar(null, _calendarFormats2.default.german);
    case "ar_EG":
      return myMoment.calendar(null, _calendarFormats2.default.arabic);
    case "ru_RU":
      return myMoment.format("DD.MM.YYYY");
    default:
  }
}

function truncateNews() {
  (0, _jquery2.default)(".c-hp-news-item__text").dotdotdot({
    height: "watch",
    keep: ".c-hp-news-item__read-more",
    watch: true
  });
}

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

module.exports = "<div class=c-hp-news-items-list> <a v-for=\"item in items\" class=c-hp-news-item tabindex=0 v-bind:href=item.link target=_blank> <div class=c-hp-news-item__date> {{ item.date }} </div> <div class=c-hp-news-item__text> {{ item.message }} <span class=c-hp-news-item__read-more> read more » </span>  </div> </a> </div> ";

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

module.exports = {"english":{"lastDay":"[Yesterday at] LT","sameDay":"[Today at] LT","nextDay":"[Tomorrow at] LT","lastWeek":"[Last] dddd [at] LT","nextWeek":"dddd [at] LT","sameElse":"LL"},"hebrew":{"sameDay":"[היום ב־]LT","nextDay":"[מחר ב־]LT","nextWeek":"dddd [בשעה] LT","lastDay":"[אתמול ב־]LT","lastWeek":"[ביום] dddd [בשעה] LT","sameElse":"LL"},"arabic":{"sameDay":"[اليوم على الساعة] LT","nextDay":"[غدا على الساعة] LT","nextWeek":"dddd [على الساعة] LT","lastDay":"[أمس على الساعة] LT","lastWeek":"dddd [على الساعة] LT","sameElse":"LL"},"german":{"sameDay":"[Heute um] LT","sameElse":"LL","nextDay":"[Morgen um] LT","nextWeek":"dddd [um] LT","lastDay":"[Gestern um] LT","lastWeek":"[Letzten] dddd [um] LT"}}

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

module.exports = {"english":["4Q1 Genesis-Exodus a","Scholars working on the Scrolls in the 1950s.","Scholars working on the Scrolls in the 1950s. Note the many problems with the workspace, including the bright sunlight from the windows and the lack of proper storage facilities ","Aerial photo of the Dead Sea","11Q1 paleo Leviticus a"],"hebrew":["4Q1 בראשית-שמות","חוקרים בעבודתם בשנות החמישים למאה העשרים","חוקרים בעבודתם בשנות החמישים למאה העשרים. שימו לב לתנאי העבודה: האור הבוהק מהחלונות והעדרם של פתרונות אחסון נאותים","צילום אווירי של ים המלח ","11Q1 פליאו-ויקרא"],"arabic":["4Q1 سفر التكوين- سفر الخروج","الباحثون خلال عملهم في سنوات الخمسينات من القرن العشرين. ","الباحثون خلال عملهم في سنوات الخمسينات من القرن العشرين. انظرو ظروف العمل: الضوء الساطع من النوافذ وعدم وجود ظروف ملائمة لتخزين المخطوطات ","تصوير من الجو لبحر الميت ","11Q1 سفر التكويين – القديم "],"german":["4Q1 Genesis-Exodus a","Wissenschaftler arbeiten in den 1950er Jahren an den Schriftrollen.","Wissenschaftler arbeiten in den 1950er Jahren an den Schriftrollen. Zu beachten sind die schlechten, die Schriftrollen gefährdenden Bedinungen, insbesondere das strahlende Sonnenlicht von den Fenstern und das Fehlen von geeigneten Lagermöglichkeiten.","Luftaufnahme von das tote Meer","11Q1 Paleolevitikus"],"russian":["4Q1 Бытие-Исход","Ученые трудятся над свитками в 1950-е гг","Ученые трудятся над свитками в 1950-е гг. Обратите внимание на ограниченноерабочее пространство, прямой солнечный свет из окон и отсутствие должного хранилища для рукописей.","Мертвое море (вид с воздуха)","11Q1 ПАЛЕО-ЛЕВИТ"]}

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breakpointSmall":"767px","breakpointMedium":"1023px"};

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = locale;

/***/ })

},[107]);


// WEBPACK FOOTER //
// js/home.js